import {useQuery} from '@tanstack/react-query'
import {useEffect} from 'react'
import api, {GetPagedServerParams} from 'src/services/api'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'

type Props = {
  params: GetPagedServerParams
  onError?: (error: unknown) => void
  enabled?: boolean
}

export default function useOutputServers({params, onError, enabled = true}: Props) {
  const query = useQuery({
    enabled,
    queryKey: [QueryKeyEnum.OUTPUT_SERVER, params],
    queryFn: async () => (await api.server.findManyPaged(params)).data.data,
  })

  useEffect(() => {
    if (query.isError) onError?.(query.error)
  }, [query.error])

  return query
}
